import React, { useState, useEffect, memo } from "react";
import { useSelector } from "react-redux";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { draggableMoveAnItem, roleCheck } from "utils/index";
import { getBaseUrl, getCurrentUser } from "../../reducers";
import { updateProcessingOrder } from "../../../../requesters/jobServiceRequester";
import DraggableProcessingJobServiceRow from "./DraggableProcessingJobServiceRow";

const ProcessingJobServicesTable = ({
  jobServices, setJobServices, reloadData
}) => {
  const baseUrl = useSelector(getBaseUrl);
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role
  const [jobServicesOfState, setJobServicesOfState] = useState(jobServices)

  const onDragEnd = result => {
    if (!result.destination) return;
    const destinationIdx = result.destination.index
    if (destinationIdx === result.source.index) return;

    const destinationJob = jobServicesOfState[destinationIdx]
    updateProcessingOrder(baseUrl, result.draggableId, destinationJob.id)
    const rows = draggableMoveAnItem(
      jobServicesOfState,
      result.source.index,
      destinationIdx
    );
    setJobServicesOfState(rows);
  }

  const MemorizedRows = memo(({ jobServices, setJobServices, reloadData }) => jobServices.map((jobService, index) => (
    <DraggableProcessingJobServiceRow
      jobService={jobService}
      setJobServices={setJobServices}
      reloadData={reloadData}
      index={index}
      key={jobService?.id} />
  )));

  const DraggableProcessingJobServiceRows = () => (
    <DragDropContext onDragEnd={result => {
      onDragEnd(result)
    }}>
      <Droppable droppableId="list">
        {provided => (
          <tbody ref={provided.innerRef} {...provided.droppableProps}>
            <MemorizedRows
              jobServices={jobServicesOfState}
              setJobServices={setJobServicesOfState}
              reloadData={reloadData} />
            {provided.placeholder}
          </tbody>
        )}
      </Droppable>
    </DragDropContext>
  )

  useEffect(() => {
    setJobServicesOfState(jobServices)
  }, [jobServices])

  return (
    <div className="table-responsive">
      <table className="table table-listing table-hover">
        <thead>
          <tr>
            <th></th>
            <th>Job No.</th>
            <th>Job Address</th>
            <th>Job Service</th>
            <th className="text-left">Surveyor</th>
            <th className="text-center absorbing-column">Date of Field Work</th>
            <th className="text-center absorbing-column">Due Date</th>
            <th></th>
          </tr>
        </thead>
        {!!jobServicesOfState.length && DraggableProcessingJobServiceRows()}
      </table>
    </div>
  )
}

export default ProcessingJobServicesTable